module.exports = __webpack_public_path__ + "assets/4756b421e326bd019a037421a21172f1.png";